export default __webpack_public_path__ + "static/media/black_powder.df07be13.png";